module.exports = __webpack_public_path__ + "img/logo4.be4b13c2.png";